import useUserRecommendationsPersonal from './useUserRecommendationsPersonal';

export default useUserRecommendationsPersonal;
